export default function PurposeTabs({ purposes = [], value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {purposes.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange?.(p)}
          className={`px-3 py-1.5 rounded-full text-xs font-medium border transition ${
            value === p
              ? "bg-gray-900 text-white border-gray-900"
              : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50"
          }`}
        >
          {p}
        </button>
      ))}
    </div>
  );
}
